const desktopNavigationItemSize = 40
const desktopNavigationItemSpacing = 8
export const desktopNavigationVisibleItemsCount = 5.45
export const desktopNavigationContainerHeight =
    5 * desktopNavigationItemSize + 5 * desktopNavigationItemSpacing + desktopNavigationItemSize * 0.25 + 8
